<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="group-seas yx-form-wrap">
			<platformTab @change="platformTabClick" :showAll="false" :platformId="platformId" />
			<Abnormal-toast
				@showReAllotDialog="showReAllotDialog"
				:showNotice="showNotice"
				:anchorCount="anchorCount"
				:showStatus="showStatus"
				:taskStatus="taskStatus"
				:platformId="platformId"
				v-show="showPlatformContent"
			></Abnormal-toast>
			<el-form inline :model="form" label-width="96px" v-show="showPlatformContent">
				<el-form-item label="达人昵称" v-if="$isPlatOr(['Dy', 'Ks'])">
					<el-input v-model="form.anchor_name" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="视频号昵称" v-if="$isSp()">
					<el-input v-model="form.anchor_name" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item :label="platformId | formatPlatformName('suf')" v-if="$isPlatOr(['Dy', 'Ks'])">
					<el-input v-model="form.anchor_account" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item :label="platformId | formatPlatformName('suf')" v-if="$isSp()">
					<el-input v-model="form.anchor_uid" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="抖音uid" v-if="$isDy()">
					<el-input v-model="form.anchor_uid" clearable placeholder="请输入抖音uid" />
				</el-form-item>
				<el-form-item label="主推类目" v-if="$isPlatOr(['Dy', 'Ks'])">
					<yx-category-select v-model="form.cate" addAll placeholder="请选择" :platformId="platformId" />
				</el-form-item>
				<el-form-item label="粉丝量" v-if="$isPlatOr(['Dy', 'Ks'])">
					<el-select v-model="form.fans_num" clearable placeholder="粉丝量">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in fansList" :key="index" />
					</el-select>
				</el-form-item>
				<el-form-item label="粉丝数" v-if="$isSp()">
					<el-select v-model="form.fans_num" clearable placeholder="粉丝量">
						<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in fansNum" :key="index" />
					</el-select>
				</el-form-item>
				<el-form-item label="认领状态">
					<el-select v-model="form.claim_status" clearable placeholder="认领状态">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in claimList" :key="index" />
					</el-select>
				</el-form-item>
				<el-form-item label="达人来源">
					<el-select v-model="form.source" clearable placeholder="请选择">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in talentOpition" :key="index" />
					</el-select>
				</el-form-item>
				<template v-if="$isDy()">
					<el-form-item label="达人等级">
						<el-select v-model="form.anchor_level" filterable placeholder="请选择">
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in talentGradeList" :key="index" />
						</el-select>
					</el-form-item>
					<el-form-item label="部门">
						<deptTreeSelect returnArray v-model="form['deptIds']" scene="groupSeas" :collapseTags="true" size="small" ref="deptTreeSelect" />
					</el-form-item>
					<el-form-item label="月橱窗销量额">
						<div class="scope-input">
							<el-input
								v-model="form.month_live_sale_min"
								clearable
								placeholder="请输入"
								@input="inputChange($event, 'month_live_sale_min')"
							></el-input>
							<span class="flag">至</span>
							<el-input
								v-model="form.month_live_sale_max"
								clearable
								placeholder="请输入"
								@input="inputChange($event, 'month_live_sale_max')"
							></el-input>
						</div>
					</el-form-item>
					<el-form-item label="场均销售额" v-if="$isDy()">
						<el-select v-model="form.live_sale" multiple collapse-tags filterable clearable placeholder="请选择">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in liveSaleList" :key="index" />
						</el-select>
					</el-form-item>
				</template>
				<template v-else>
					<el-form-item label="30日销售额">
						<el-select v-model="form.fee_30" filterable clearable placeholder="请选择">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in monthLiveSaleList" :key="index" />
						</el-select>
					</el-form-item>
					<el-form-item label="场均销售额">
						<el-select v-model="form.live_sale" multiple collapse-tags filterable clearable placeholder="请选择">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in liveSaleList" :key="index" />
						</el-select>
					</el-form-item>
				</template>
				<template v-if="$isSp()">
					<el-form-item label="部门">
						<deptTreeSelect returnArray v-model="form['deptIds']" scene="groupSeas" :collapseTags="true" size="small" ref="deptTreeSelect" />
					</el-form-item>
				</template>
				<el-form-item label="跟进人">
					<el-select v-model="form.user_id" filterable clearable placeholder="请选择">
						<el-option :label="item.name" :value="item.id" v-for="(item, index) in partner_list" :key="index">
							<div class="flex flex-align-center">
								<span class="mr-8">{{ item.name }}</span>
								<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
								<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
							</div>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="达人标签" prop="tags_id" v-if="$auth.hasPermi('team-sea:search-tags')">
					<SelectTag ref="selectTag" style="width: 100%" :collapseTags="true" type="1" :multiple="true" v-model="form.tag_ids"></SelectTag>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getList">筛选</el-button>
					<el-button @click="onClear">清空</el-button>
				</el-form-item>
			</el-form>
		</Panel>
		<Panel :contentPaddingTop="12" v-show="showPlatformContent">
			<div class="mt-24 flex flex-align-center flex-just-between">
				<div class="flex flex-align-center flex-just-between flex-1">
					<div>
						<el-checkbox @change="checkeFun" v-model="allChecked" class="mr-18 ml-16">当页全选</el-checkbox>
						<el-button v-if="$auth.hasPermi('system:groupSeas:create')" type="primary" @click="showAddTalentDialog">新建达人</el-button>
						<el-tooltip
							content="请先选择达人"
							:disabled="!!selectionTalent.length"
							placement="top"
							v-if="$auth.hasPermi('team-sea:tags:batch-set-anchor-tags')"
						>
							<el-button @click="addTags" style="margin-left: 12px">批量打标</el-button>
						</el-tooltip>
						<template v-if="$auth.hasPermi('system:talent:allocation/re-allocation')">
							<el-tooltip class="item" effect="dark" content="请先选择达人" placement="bottom" :disabled="selectLen ? true : false">
								<el-button @click="showDisTipDialog">批量分配/重新分配</el-button>
							</el-tooltip>
							<el-button @click="gotoAllocatedRecord">分配记录</el-button>
						</template>
						<el-tooltip class="item" effect="dark" content="请先选择达人" placement="bottom" :disabled="selectLen ? true : false">
							<el-button @click="modifyCooperation()" v-auth="['team-sea:seller:partner-anchor:batch-modify']">修改状态</el-button>
						</el-tooltip>
						<el-button
							@click="
								joinBlackList(
									'batch',
									selectionTalent.map(item => item.anchor_id),
								)
							"
							v-auth="['groupSeas:blacklist-anchor:block']"
						>
							加入黑名单
						</el-button>
					</div>
					<div class="flex flex-align-center">
						<button-group>
							<el-checkbox v-model="form.effect_status" :true-label="1" :false-label="0" @change="getList(true)">过滤失效达人</el-checkbox>
						</button-group>
						<template v-if="$auth.hasPermi('system:groupSeas:lead-into')">
							<button-group>
								<el-button @click="showImportDialog">导入</el-button>
								<el-button @click="goToPage">导入记录</el-button>
							</button-group>
						</template>
						<button-group v-if="$auth.hasPermi('system:talent:export')">
							<export-list
								ref="exportList"
								:routerPath="routerPath"
								:platformId="platformId"
								:exportInterface="exportInterface"
								:exportDialog="exportDialog"
							></export-list>
						</button-group>
					</div>
				</div>
			</div>
			<multi-table
				:key="platformId"
				class="mt-24"
				ref="multiTable"
				:page="pageInfo"
				:list="list"
				:columns="columns"
				:options="options"
				@gePartnerList="gePartnerPage"
				:selectionChange="talentChange"
				:total="total"
			>
				<template v-slot:empty>
					<div class="empty-page">
						<div class="i-empty-customer"></div>
						<div class="text">暂无达人数据</div>
						<div class="btns">
							<el-button v-if="$auth.hasPermi('system:groupSeas:create')" type="primary" @click="showAddTalentDialog">添 加</el-button>
							<el-button v-if="$auth.hasPermi('system:groupSeas:lead-into')" type="primary" @click="showImportDialog">批量添加</el-button>
						</div>
					</div>
				</template>
			</multi-table>
		</Panel>
		<modify-cooperation-status ref="modifyCooperationStatus" source="public" @refresh="getList"></modify-cooperation-status>
		<add-talent-dialog sourcePage="groupSeas" :platform-id="platformId" ref="addTalentDialog" @refresh="getList" />
		<import-dialog sourcePage="groupSeas" :platform-id="platformId" ref="importDialog" @getList="getList" />
		<anew-allocation-dialog ref="anewAllocationDialog" @getList="getList" />
		<allocation-dialog ref="allocationDialog" @getList="getList" :drnums="selectLen" :platform_id="platformId" />
		<detail-drawer ref="detailDrawer" @getList="getList" :activeTab="'3'" />
		<ReAllot-dialog ref="reAllotDialog" :platformId="platformId" @changeStatus="changeStatus" @getTaskStatus="getTaskStatus"></ReAllot-dialog>
		<el-dialog title="提示" :visible.sync="disTipDialog" width="426px" class="tipDialog">
			<i class="el-icon-warning mr-6 fz-18" style="color: #ff7038"></i>
			<span>若选中的达人正在进行分配任务, 继续操作将按此次操作分配选中达人</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="disTipDialog = false">取 消</el-button>
				<el-button type="primary" @click="showAllocatePartners">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 添加标签 -->
		<tagDialog ref="tagDialog" type="1" @refreshList="refreshList"></tagDialog>

		<!-- 加入黑名单 -->
		<join-black-list-dialog ref="joinBlackListDialog" :platformId="platformId" @refresh="getList" />
	</div>
</template>

<script>
import addTalentDialog from '@/views/common/dialog/addTalent';
import AbnormalToast from '../components/abnormalToast';
import ReAllotDialog from '../components/reAllotDialog';
import exportList from '@/views/common/exportList';
import importDialog from '@/views/talentCRM/myTalent/components/importDialog';
import tooltip from '../components/tooltip';
import anewAllocationDialog from './components/anewAllocationDialog';
import detailDrawer from '../components/detailDrawer';
import talentInfo from '../components/talentInfo';
import popover from '@/views/talentCRM/myTalent/components/popover';
import allocationDialog from './components/allocationDialog';
import { platformMixin } from '@rd/rd-ui';
import yxCategorySelect from '@/components/yxCategorySelect';
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
import { mapGetters } from 'vuex';
import throttle from 'lodash/throttle';
import { fansList, ksLiveSaleList, PLATFORM_DY, drRoleType, talentGradeList, authStatusList } from '@/utils/dataMap';
import { getTeamSeaList, teamSeaClaim, teamSeaExport, getPartnerAnchor, clueSelectList, partnerList, checkMultiFollow } from '@/api/talentCRM';
import ButtonGroup from '@/components/ui/buttonGroup';
import { getColums } from './columns';
import SelectTag from '@/components/business/tagDialog/selectTag';
import tagDialog from '@/components/business/tagDialog';
import ModifyCooperationStatus from '@/views/talentCRM/components/modifyCooperationStatus/index.vue';
import talentCRMMixin from '../components/mixins';
import joinBlackListDialog from '@/views/talentCRM/components/joinBlackListDialog';

export default {
	name: 'groupSeas',
	components: {
		ModifyCooperationStatus,
		addTalentDialog,
		importDialog,
		tooltip,
		anewAllocationDialog,
		detailDrawer,
		popover,
		allocationDialog,
		yxCategorySelect,
		talentInfo,
		exportList,
		ButtonGroup,
		AbnormalToast,
		ReAllotDialog,
		deptTreeSelect,
		SelectTag,
		tagDialog,
		joinBlackListDialog,
	},
	provide() {
		return {
			refresh: this.getList,
			showDetailDrawer: row => this.showdetailDrawer(row.anchor_id),
		};
	},
	mixins: [platformMixin, talentCRMMixin],
	data() {
		return {
			form: {
				anchor_name: '',
				anchor_account: '',
				cate: '',
				fans_num: '',
				anchor_level: -1,
				fee_30: 0,
				live_sale: 0,
				effect_status: 0,
				deptIds: [],
				source: 0,
			},
			fansList,
			claimList: [
				{
					label: '已认领',
					value: 1,
				},
				{
					label: '未认领',
					value: -1,
				},
				{
					label: '认领已到期',
					value: 2,
				},
			],
			talentOpition: [
				{
					label: '全部',
					value: 0,
				},
				{
					label: '线索公海',
					value: 1,
				},
				{
					label: '达人小程序',
					value: 3,
				},
				{
					label: '手动添加/导入',
					value: 2,
				},
				{
					label: '官方达人广场',
					value: 4,
				},
			],
			list: [],
			selectionTalent: [],
			many_partner: 0,
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			user_id: '',
			platformId: '',
			monthLiveSaleList: [],
			ksLiveSaleList: [{ value: 0, label: '全部' }, ...ksLiveSaleList],
			liveSaleList: [],
			talentGradeList,
			authStatusList,
			routerPath: '/talentCRM/record',
			allChecked: false,
			disTipDialog: false,
			source: '', //是否单个分配
			anchorCount: 0,
			showNotice: false,
			taskStatus: 0,
			wait_fix: 0,
			showStatus: 0,
			timer: null,
			partner_list: [],
			options: {
				selectable: true,
				border: false,
			},
			fansNum: [],
		};
	},
	created() {
		let tag_id = this.$route.query.tag_id || '';
		let source = this.$route.query.source || '';
		let claim_status = this.$route.query.claim_status || '';
		if (tag_id) this.form.tag_ids = tag_id;
		if (source) {
			this.form.source = Number(source);
		}
		if (claim_status) {
			this.form.claim_status = Number(claim_status);
		}
		// this.platformId = +this.defaultPlatform;
		this.clueSelectList();
		this.getList();
		this.getTalentStatus();
		this.partnerList();
	},
	destroyed() {
		clearInterval(this.timer);
		this.timer = null;
		this.showNotice = false;
		this.showStatus = 0;
	},
	computed: {
		...mapGetters(['defaultPlatform']),
		partners() {
			return (partners = []) => partners.map(item => item.partner_name).join('、');
		},
		drName() {
			return drRoleType.name;
		},
		selectLen() {
			return this.selectionTalent.length;
		},
		columns() {
			const columns = getColums(this).filter(item => {
				return item.isAuth && item.show;
			});
			return columns;
		},
	},
	methods: {
		async clueSelectList() {
			const { code, data } = await clueSelectList({ platformId: this.platformId });
			if (code != 0) return;
			this.liveSaleList = data.liveSale || [];
			this.monthLiveSaleList = data.fee30 || [];
			this.fansNum = data.fansNum || [];
		},
		getList: throttle(async function (isInit) {
			isInit && this.resetPage();
			const { form, pageInfo, platformId: platform_id } = this;
			let formCopy = {};
			Object.keys(form).forEach(key => {
				formCopy[key] = Array.isArray(form[key]) && key !== 'deptIds' ? form[key].join(',') : form[key];
			});
			const { code, data: { list = [], many_partner, user_id, page = {} } = {} } = await getTeamSeaList({ ...formCopy, ...pageInfo, platform_id });
			if (code !== 0) return;
			this.user_id = user_id;
			this.many_partner = many_partner;
			this.list = list.map(item => {
				return {
					...item,
					many_partner: many_partner,
					operations: this.getButtons(item),
				};
			});
			this.claimList =
				many_partner === 1
					? [
							{
								label: '已认领',
								value: 1,
							},
							{
								label: '未认领',
								value: -1,
							},
					  ]
					: [
							{
								label: '已认领',
								value: 1,
							},
							{
								label: '未认领',
								value: -1,
							},
							{
								label: '认领已到期',
								value: 2,
							},
					  ];
			this.total = page.item_total;
		}, 1000),
		getButtons(item) {
			const arr = [];
			arr.push(
				{
					label: '重新分配',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:talent:allocation/re-allocation') && item.is_contact,
					click: row => this.showAnewAllocationDialog(row.anchor_id),
				},
				{
					label: '分配',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:talent:allocation/re-allocation') && !item.is_contact,
					click: row => this.showAllocationDialog(row.anchor_id, 'allocatePartner'),
				},
				{
					label: '认领',
					type: 'text',
					classtype: 2,
					isShow:
						this.$auth.hasPermi('system:groupSeas:claimant') &&
						(!item.is_contact ||
							(this.many_partner && !this.checkPartnar(item.partners)) ||
							(!this.many_partner && item.partners.length && item.partners[0].is_expire == '1' && this.user_id != item.partners[0].user_id)),
					click: row => this.teamSeaClaim(row.anchor_id),
				},
				{
					label: '详情',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: row => this.showdetailDrawer(row.anchor_id),
				},
				{
					label: '修改状态',
					type: 'text',
					tooltipContent: '达人存在多商务跟进，请前往［我的达人］修改合作状态',
					disabledTooltip: item.partners.length > 1,
					disabled: item.partners.length > 1,
					classtype: 2,
					isShow: this.$auth.hasPermi('team-sea:seller:partner-anchor:batch-modify'),
					click: row => this.modifyCooperation(row.anchor_id),
				},
				{
					label: '加入黑名单',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('groupSeas:blacklist-anchor:block'),
					click: row => {
						this.joinBlackList('single', row.anchor_id);
					},
				},
			);
			let filterArr = arr.filter(v => v.isShow);
			filterArr.tagDialog = this.addTag;
			return filterArr;
		},
		onClear() {
			this.form = {
				anchor_name: '',
				anchor_account: '',
				cate: '',
				fans_num: '',
				anchor_level: -1,
				fee_30: 0,
				live_sale: 0,
				effect_status: 0,
				deptIds: [],
				source: 0,
			};
			this.$refs.selectTag?.reset();
			this.getList(true);
		},
		//加入黑名单
		joinBlackList(type = 'single', val) {
			if (type === 'batch') {
				if (!this.selectionTalent.length) {
					this.$message.warning('请选择达人');
					return;
				}
			}
			this.$refs.joinBlackListDialog.show(type, val);
		},
		resetPage() {
			this.pageInfo.page_index = 1;
			this.$refs.multiTable.resetPage();
		},
		refreshList() {
			this.getList();
		},
		checkPartnar(partners) {
			return partners.some(({ user_id }) => user_id == this.user_id);
		},
		showAddTalentDialog() {
			this.$refs.addTalentDialog.show();
		},
		showImportDialog() {
			this.$refs.importDialog.show();
		},
		goToPage() {
			this.$router.push('/talentCRM/groupSeas/importLog');
		},
		gePartnerPage(val) {
			const { page_index, page_size } = val;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getList();
		},
		showAnewAllocationDialog(anchor_id) {
			this.$refs.anewAllocationDialog.show(anchor_id);
		},
		showdetailDrawer(anchor_id) {
			this.$refs.detailDrawer.show(anchor_id);
		},
		teamSeaClaim: throttle(async function (anchor_id) {
			const { code } = await teamSeaClaim({ anchor_id });
			if (code !== 0) return;
			this.$message.success('认领成功');
			this.getList();
		}, 1000),
		showAllocationDialog(anchor_id, source) {
			this.$refs.allocationDialog.show(anchor_id, null, source);
		},
		platformTabClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.pageInfo = {
				page_index: 1,
				page_size: 20,
			};
			this.clueSelectList();
			this.getTalentStatus();
			this.onClear();
		},
		async exportInterface(that) {
			const { form, pageInfo, platformId: platform_id } = this;
			let formCopy = {};
			Object.keys(form).forEach(key => {
				formCopy[key] = Array.isArray(form[key]) && key !== 'deptIds' ? form[key].join(',') : form[key];
			});
			const { code } = await teamSeaExport({ ...formCopy, ...pageInfo, platform_id, opt_type: 1 });
			if (code === 0) {
				that.$refs.exportDialog.show(this.exportDialog);
			}
		},
		async exportDialog() {
			const { form, pageInfo, platformId: platform_id, routerPath } = this;
			let formCopy = {};
			Object.keys(form).forEach(key => {
				formCopy[key] = Array.isArray(form[key]) && key !== 'deptIds' ? form[key].join(',') : form[key];
			});
			const { code } = await teamSeaExport({ ...formCopy, ...pageInfo, platform_id, opt_type: 2 });
			if (code === 0) {
				const handLink = this.$router.resolve({
					path: routerPath,
					query: { platform_id },
				});
				window.open(handLink.href, '_blank');
			}
		},
		showAllocatePartners() {
			this.disTipDialog = false;
			this.$refs.allocationDialog.Show(this.selectionTalent, this.source);
		},
		//选中值
		checkeFun(e) {
			this.filterArr = [];
			this.filterArr = this.list.filter(item => ![2, 3].includes(item.other_status));
			this.$refs.multiTable.toggleSelection(this.list, e);
		},
		showDisTipDialog() {
			if (this.selectionTalent == 0) return;
			this.source = 'allocatePartners'; //团队公海批量分配
			this.disTipDialog = true; //显示提示框
		},

		talentChange(val) {
			this.selectionTalent = val;
			//如果商品总数小于当前分页的总数，那么当长度等于total，为全选 如果商品总数大于当前的分页，那么长度等于当前的分页
			if (this.total <= this.pageInfo.page_size) {
				if (this.selectLen == this.total) return (this.allChecked = true);
			} else {
				if (this.selectLen == this.pageInfo.page_size) return (this.allChecked = true);
			}
			this.allChecked = this.selectLen && this.selectLen === this.filterArr?.length;
		},
		gotoAllocatedRecord() {
			const { platformId: platform_id } = this;
			const openCatedRecord = this.$router.resolve({
				path: '/talentCRM/allocatedrecord',
				query: { platform_id },
			});
			window.open(openCatedRecord.href, '_blank');
		},
		async modifyCooperation(val = '') {
			if (val) {
				this.$refs.modifyCooperationStatus.show(val, [1]);
			} else {
				if (!this.selectLen) return;
				let anchorIds = this.selectionTalent.map(item => item.anchor_id);
				const {
					code,
					data: { multiFollow },
				} = await checkMultiFollow({ anchorIds });
				if (code !== 0) return;
				this.$refs.modifyCooperationStatus.show(val, anchorIds, multiFollow, 'group');
			}
		},
		showReAllotDialog() {
			const { platformId } = this;
			this.$refs.reAllotDialog.show(platformId);
		},
		async getTalentStatus() {
			const {
				code,
				data: { wait_fix, task_status, wait_fix_num, many_partner },
			} = await getPartnerAnchor({ platform_id: this.platformId });
			if (code !== 0) return;
			this.taskStatus = task_status;
			this.anchorCount = wait_fix_num;
			this.wait_fix = wait_fix;

			if (!many_partner && Number(wait_fix_num) > 0) {
				//暂时显示，正式为！many_partner
				//不允许1对多的情况且存在多条数据时，会显示改提示
				this.showNotice = true;
				this.showStatus = 1;
			} else {
				this.showNotice = false;
				this.showStatus = 0;
			}
		},
		//轮询来观测任务状态
		getTaskStatus() {
			this.timer = setInterval(async () => {
				const { task_status } = await getPartnerAnchor({ platform_id: this.platformId });
				if (task_status) {
					this.showStatus = 2;
				} else {
					this.showStatus = 3;
					clearInterval(this.timer);
				}
			}, 1000);
		},
		changeStatus(val) {
			this.showStatus = val;
		},
		async partnerList() {
			const { code, data } = await partnerList({ role_id: drRoleType.id, all_status: 1 });
			if (code !== 0) return;
			this.partner_list = data;
			// 将数组分成三个部分
			const notUseStatus2AndNotDeleted = this.partner_list.filter(item => item.use_status !== '2' && !item.deleted);
			const useStatus2 = this.partner_list.filter(item => item.use_status === '2');
			const deleted = this.partner_list.filter(item => item.deleted);
			// 合并三个部分
			this.partner_list = [...notUseStatus2AndNotDeleted, ...useStatus2, ...deleted];
		},
		addTag(row) {
			this.$refs.tagDialog.show('编辑标签', [row]);
		},
		addTags() {
			if (!this.selectionTalent.length) return;
			this.$refs.tagDialog.show('批量添加标签', this.selectionTalent);
		},
	},
};
</script>

<style lang="less" scoped>
.group-seas {
	.empty-page {
		margin-top: 100px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.i-empty-customer {
			width: 240px;
			height: 240px;
		}

		.text {
			font-size: 16px;
			color: #999999;
			margin-top: 24px;
		}

		.btns {
			margin-top: 32px;
		}
	}

	.import-log {
		font-size: 14px;
		color: #333;
		display: flex;
		align-items: center;
		cursor: pointer;
		margin-left: 8px;

		.iconfont {
			font-size: 24px;
			vertical-align: middle;
		}

		&:hover {
			color: @color-primary;
		}
	}

	.expire {
		font-size: 12px;
		color: #fa8f14;

		::v-deep .icon-a-help-circle-obangzhu-xian {
			font-size: 12px;
			color: #fa8f14;
		}
	}

	.claim-status {
		display: flex;
		align-items: center;

		&::before {
			content: '';
			width: 8px;
			height: 8px;
			border-radius: 50%;
			margin-right: 8px;
		}

		&.success::before {
			background-color: @color-success;
		}

		&.warning::before {
			background-color: @color-warning;
		}

		&.error::before {
			background-color: @color-danger;
		}
	}

	.follow {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
	}
}
/deep/ .el-table__fixed {
	box-shadow: 8px 3px 7px rgba(0, 0, 0, 0.08);
}
/deep/ .el-table__fixed-right {
	box-shadow: -3px 3px 3px rgba(0, 0, 0, 0.08);
}
</style>
